import React from 'react';
import {Box, Card, Chip, Typography} from "@mui/material";
import {CreditCardRounded, HourglassTopRounded} from "@mui/icons-material";

const _UserPayTransactions = () => {
    return (
        <Card
            elevation={0}
            sx={{
                width: '100%',
                borderRadius: 4,
                border: '1px solid',
                borderColor: 'divider',
                bgcolor: 'background.paper',
                boxShadow: '0 2px 14px rgba(0, 0, 0, 0.03)',
                p: { xs: 4, sm: 6 },
                textAlign: 'center'
            }}
        >
            <Box
                sx={{
                    width: 72,
                    height: 72,
                    borderRadius: '50%',
                    bgcolor: 'rgba(28, 139, 156, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mx: 'auto',
                    mb: 2.5,
                    color: 'primary.main'
                }}
            >
                <CreditCardRounded sx={{ fontSize: 36 }} />
            </Box>

            <Chip
                icon={<HourglassTopRounded sx={{ fontSize: 16 }} />}
                label="در حال توسعه — به‌زودی"
                size="small"
                sx={{
                    fontWeight: 700,
                    borderRadius: 2,
                    mb: 2,
                    bgcolor: 'rgba(28, 139, 156, 0.08)',
                    color: 'primary.main',
                    border: '1px solid',
                    borderColor: 'rgba(28, 139, 156, 0.2)'
                }}
            />

            <Typography variant="h6" sx={{ fontWeight: 800, mb: 1, color: 'text.primary' }}>
                گزارش پرداخت‌های شخصی کارمندان
            </Typography>

            <Typography variant="body2" sx={{ color: 'text.secondary', maxWidth: 460, mx: 'auto', lineHeight: 1.8 }}>
                این بخش به کارمندان سازمان امکان می‌دهد مازاد هزینه خدمات ورزشی فراتر از سقف اعتبار سازمانی را به صورت مستقیم از درگاه شخصی پرداخت نمایند. آمار و گزارش این تراکنش‌ها در این بخش در دسترس خواهد بود.
            </Typography>
        </Card>
    );
};

export default _UserPayTransactions;
